<!-- Hero Section -->
<div class="relative">
  <img src="assets/events-hero.webp" class="mobile-m:h-[530px] h-[350px] w-full object-cover brightness-[.9]">
  <div class="absolute inset-0 flex flex-col items-center justify-center">
    <h1 class="text-[var(--white)] mobile-m:text-[73px]/[73px] text-[60px]/[60px] uppercase">{{ 'events.title' | translate }}</h1>
    <p class="text-[var(--white)] mobile-m:text-[40px]/[40px] text-[25px]/[25px] font-normal">{{ 'events.subtitle' | translate }}</p>
  </div>
</div>

<!-- Title bar -->
<div class="bg-[var(--black)]">
  <div class="mx-auto max-w-screen-desktop container-padding">
    <h2 class="text-[var(--yellow)] uppercase text-[34px]/[34px] font-normal mobile-m:text-left text-center py-5 m-0">
      {{ 'events.upcomingEvents' | translate }}
    </h2>
  </div>
</div>

<!-- Events Showcase (reusable component) -->
<app-events-showcase
  [events]="events"
  [isLoading]="isLoadingEvents"
  [showFilters]="false"
  [showTitle]="false">
</app-events-showcase>

<!-- Create your own route CTA -->
<div *ngIf="!isLoadingEvents && events.length > 0" class="bg-[var(--light-grey)] pb-12">
  <div class="mx-auto max-w-screen-desktop container-padding">
    <div class="flex flex-col mobile-m:flex-row items-center justify-between gap-4 p-6 rounded-2xl bg-[var(--beige)] border-2 border-[var(--grey)]">
      <div>
        <p class="text-[var(--tertiary)] font-semibold text-[15px] m-0">{{ 'events.customRouteCta' | translate }}</p>
        <p class="text-[var(--dark-grey)] text-[13px] m-0 mt-1">{{ 'events.customRouteDesc' | translate }}</p>
      </div>
      <app-button [function]="goToNewHop.bind(this)" [text]="'events.createRoute' | translate" [styleType]="'primary'"></app-button>
    </div>
  </div>
</div>
